import { DestroyRef, Pipe, PipeTransform, inject } from '@angular/core';
import { StockService } from './stock.service';
import { StockInfo, StockMap } from '@pedix-workspace/shared-stock';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { toObservable, takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Pipe({
  name: 'pxwStockInfo',
  standalone: true,
})
export class StockInfoPipe implements PipeTransform {
  private stockService = inject(StockService);
  private destroyRef = inject(DestroyRef);

  stock$: Observable<StockMap>;

  constructor() {
    this.stock$ = toObservable(this.stockService.stock);
  }

  transform(cartItemId: string): Observable<StockInfo> {
    return this.stock$.pipe(
      takeUntilDestroyed(this.destroyRef),
      map(stock => stock.getStockInfoByItem(cartItemId)),
    );
  }
}
